import whereAmI from './whereAmI';
var hasSearchParam = function hasSearchParam(name, value) {
  var _window, _window$location;
  if (whereAmI.onServer) return false;
  var searchParams = new URLSearchParams((_window = window) == null ? void 0 : (_window$location = _window.location) == null ? void 0 : _window$location.search);
  var hasParam = searchParams.has(name);
  var hasValuesToCompare = hasParam && typeof value === 'string';
  return hasValuesToCompare ? searchParams.get(name) === value : hasParam;
};
export default hasSearchParam;